import { z } from "zod";

/**
 * RootNodeSchema - Content Schema for Root Node
 *
 * Root node represents the entire editor content tree.
 * All content must be nested under a single root.
 */
export const RootNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("root"),
  version: z.literal(1),
  key: z.string(),

  // Business data
  children: z.array(z.any()), // Array of child nodes (ParagraphNode, etc.)
  direction: z.enum(["ltr", "rtl", "null"]).optional(),
}).strict();

export type RootNode = z.infer<typeof RootNodeSchema>;
